webpackJsonp([37],{

/***/ 2305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.route)(_AppConstants.CheckoutStages.PAYMENT, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(52).then((function (require) {
            cb(null, __webpack_require__(3188).default);
        }).bind(null, __webpack_require__)).catch(function () {
            // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
            // TODO: use a smarter way to get an updated chunk
            window.location.reload();
        });
    }
});

/***/ }),

/***/ 2306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.route)(_AppConstants.CheckoutStages.PAYMENT_AMAZON_PAY, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(52).then((function (require) {
            cb(null, __webpack_require__(3197).default);
        }).bind(null, __webpack_require__)).catch(function () {
            // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
            // TODO: use a smarter way to get an updated chunk
            window.location.reload();
        });
    }
});

/***/ }),

/***/ 2307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.featureRoute)('enablePay360Hosted', _AppConstants.CheckoutStages.PAYMENT_CARD_HOSTED, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(58).then((function (require) {
            cb(null, __webpack_require__(3201).default);
        }).bind(null, __webpack_require__)).catch(function () {
            // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
            // TODO: use a smarter way to get an updated chunk
            window.location.reload();
        });
    }
});

/***/ }),

/***/ 2308:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _helpers = __webpack_require__(60);

var _AppConstants = __webpack_require__(6);

module.exports = (0, _helpers.featureRoute)('enableBraintreeCardPayments', _AppConstants.CheckoutStages.PAYMENT_CARD_HOSTED_BRAINTREE, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(61).then((function (require) {
            cb(null, __webpack_require__(2910).default);
        }).bind(null, __webpack_require__)).catch(function () {
            // Adding fallback to prevent blank pages when the chunk is not available (I.E: after a release).
            // TODO: use a smarter way to get an updated chunk
            window.location.reload();
        });
    }
});

/***/ }),

/***/ 2309:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _urls = __webpack_require__(51);

var _urls2 = _interopRequireDefault(_urls);

var _helpers = __webpack_require__(60);

var _OrderStore = __webpack_require__(80);

var _OrderStore2 = _interopRequireDefault(_OrderStore);

var _AppConstants = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = [(0, _helpers.route)(_AppConstants.CheckoutStages.AMAZON_PAY_MFA_SUCCESS, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(52).then((function () {
            cb(null, function () {
                return null;
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function onEnter(nextState, replace) {
        var currentOrder = _OrderStore2.default.getCurrent();
        replace(_urls2.default.location(_AppConstants.CheckoutStages.PAYMENT_AMAZON_PAY, null, null, {
            state: {
                amazonPayMFASuccess: true,
                isPostalDelivery: currentOrder.isPostalDelivery()
            }
        }));
    }
}), (0, _helpers.route)(_AppConstants.CheckoutStages.AMAZON_PAY_MFA_FAILURE, {
    getComponent: function getComponent(location, cb) {
        __webpack_require__.e/* require.ensure */(52).then((function () {
            cb(null, function () {
                return null;
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    onEnter: function onEnter(nextState, replace) {
        replace(_urls2.default.location(_AppConstants.CheckoutStages.PAYMENT, null, null, {
            state: { amazonPayMFAFailure: true }
        }));
    }
})];

/***/ })

});


// WEBPACK FOOTER //
// js/pages/payment-routes.5eec35b36e307edfa719.js